import { EditorInput, EditorInputProps } from "../editor/editor-input";
import { Field, FieldDescription, FieldLabel } from "../ui/field";
import { FieldErrors, FieldProps } from "./field";

export function EditorInputField({
  label,
  description,
  errors,
  fieldProps,
  ...props
}: EditorInputProps & FieldProps) {
  return (
    <Field {...fieldProps}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <EditorInput aria-invalid={errors && errors.length > 0} {...props} />
      {description && <FieldDescription>{description}</FieldDescription>}
      <FieldErrors errors={errors} />
    </Field>
  );
}
